<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import url('/assets/css/base.css');
</style>



// WEBPACK FOOTER //
// src/App.vue